import { Stack } from "@mui/material";
import { m } from "framer-motion";
import { useContext } from "react";
import Logo from "src/components/Logo";

import ConextManager from "../../context";
import CodeInputs from "./components/CodeInputs/CodeInputs";
import EmailInput from "./components/EmailInput";
import VerifyTitle from "./components/VerifyTitle";
import Context from "./context";
import useDemoCodeActionsStore from "./store";

// ----------------------------------------------------------------------

export const VerifyStep = () => {
	const [state, actions] = useDemoCodeActionsStore();
	const conextManager = useContext(ConextManager);

	const hasEmail = conextManager.state.email === "";

	return (
		<Context.Provider value={{ actions, state }}>
			<Stack
				component={m.div}
				initial={{ opacity: 0 }}
				animate={{ opacity: 1 }}
				transition={{ duration: 0.6 }}
			>
				<Logo sx={{ mb: 4 }} disabledLink />
				<VerifyTitle />
				{hasEmail && <EmailInput />}
				{!hasEmail && <CodeInputs />}
			</Stack>
		</Context.Provider>
	);
};

export default VerifyStep;
